import React, { useEffect, useState, useContext, useRef } from 'react';

import { useNavigate } from 'react-router-dom';
import GeneralModal from '../../helpers/GeneralModal';
import { createModal } from 'react-modal-promise';
import LogicContext from '../../Context/LogicContext';
import { useForm } from 'react-hook-form';
import { packageService } from '../../services/packageService';
import { GetPackageEditAtom, SetPackageEditAtom } from '../../store/packageStore';
import moment from 'moment';
import CurrencyFormat from 'react-currency-format';
import ShippingCheck from './ShippingCheck';
import { formatCustomNumber } from '../../helpers/formatCustomNumber';

function PackageNewShipping() {
  const navigate = useNavigate();
  const getPackageEditAtom = GetPackageEditAtom();
  const setPackageEditAtom = SetPackageEditAtom();
  const myPromiseModal = createModal(GeneralModal);
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const logicContext = useContext(LogicContext);
  const [selectedSalesOrder, setSelectedSalesOrder] = useState([]);
  const [showOption, setShowOption] = useState(false);

  useEffect(() => {
    if (getPackageEditAtom?.length) {
      setSelectedSalesOrder(getPackageEditAtom);
      setValue('sales_order_ref_no', getPackageEditAtom[0]?.sales_order_ref_no);
      setValue('shipment_delivered_status_id', getPackageEditAtom[0]?.sales_order_ref_no);
    }

    return () => {
      setPackageEditAtom([]);
    };
  }, []);

  function shipmentDate() {
    let defaultDate = moment(Date.now()).format('YYYY-MM-DD');
    if (getPackageEditAtom[0]?.package_date !== undefined) {
      defaultDate = moment(getPackageEditAtom[0]?.package_date).format('YYYY-MM-DD');
    }

    return (
      <input
        type="date"
        defaultValue={defaultDate}
        className="w-full border border-gray-300 rounded-md shadow-sm p-2"
        {...register('shipment_date', {
          required: 'Shipment is required',
        })}
      />
    );
  }

  function deliveryDate() {
    // let defaultDate = moment(Date.now()).format("YYYY-MM-DD")
    // if(getPackageEditAtom[0]?.Pickup_Date !== undefined){
    //    defaultDate = moment(getPackageEditAtom[0]?.Pickup_Date).format("YYYY-MM-DD")
    // }
    return (
      <>
        <input
          type="date"
          // defaultValue={defaultDate}
          className="w-full border border-gray-300 rounded-md shadow-sm p-2"
          {...register('shipment_delivery_date')}
        />
      </>
    );
  }
  function deliveryTime() {
    // let defaultDate = moment(Date.now()).format("YYYY-MM-DD")
    // if(getPackageEditAtom[0]?.Pickup_Date !== undefined){
    //    defaultDate = moment(getPackageEditAtom[0]?.Pickup_Date).format("YYYY-MM-DD")
    // }
    return (
      <>
        <input
          type="time"
          // defaultValue={defaultDate}
          className="w-full border border-gray-300 rounded-md shadow-sm p-2"
          {...register('shipment_delivery_time')}
        />
        <small className="text-red-500">{Boolean(errors['pickup_date']?.message) && String(errors['pickup_date']?.message)}</small>
      </>
    );
  }

  const onSubmit = async () => {
    await myPromiseModal({
      title: 'Confirmation',
      body: ' Do you want to save this record?',
      showInput: false,
      placeHolder: '',
      showInput: false,
      placeHolder: '',
    })
      .then(res => {
        if (res.decision === true) {
          const newData = getValues();
          let option = 16;

          packageService.subOrUpdatePackage({ ...newData, option }).then(res => {
            if (res?.data !== undefined) {
              const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
              const { message_id, message_text } = cleanResponse;
              if (message_id == 1) {
                logicContext.showToast(message_text, 'success');
                navigate(-1);
              }
            }
          });
        }
      })
      .catch(err => {
        console.log('Error ', err);
        // logicContext.showToast('error submitting record', 'error');
      });
  };

  function onErrors(error) {
    logicContext.showToast('Form error', 'error');
  }

  const onStatusCheck = val => {
    setShowOption(val);
    if (val) {
      setValue('shipment_delivered_status_id', 1);
    } else {
      setValue('shipment_delivered_status_id', 2);
    }

    // setIsChecked(!isChecked);
  };

  const calculateDiscount = pkg => {
    console.log('pkg ', pkg);
    let totalDiscount = 0;
    if (pkg?.discount_type_id === 1) {
      totalDiscount = pkg?.discount_amount || 0;
      return formatCustomNumber(totalDiscount);
    }

    return 0;
  };

  return (
    <div className="p-8">
      <form onSubmit={handleSubmit(onSubmit, onErrors)}>
        <h1 className="text-xl font-semibold mb-6 flex items-center">New Shipment - {getPackageEditAtom[0]?.sales_order_ref_no}</h1>
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className=" text-sm ">Package Slip#</label>
              <input
                type="text"
                value={getPackageEditAtom[0]?.package_slip_number}
                className="w-full border border-gray-300 rounded-md shadow-sm p-2"
                readOnly
              />
              <small className=""> Auto generated </small>
            </div>

            {/* <div>
          
          </div> */}
            <div>
              <label className=" text-sm">Shipment Date</label>
              {shipmentDate()}
            </div>
          </div>

          {/* Table Section */}
          <table className="w-full bg-white border mt-3">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b">#</th>
                <th className="py-2 px-4 border-b">Item & Description</th>
                <th className="py-2 px-4 border-b">Qty</th>
                <th className="py-2 px-4 border-b">Rate</th>
                <th className="py-2 px-4 border-b">Discount</th>
                <th className="py-2 px-4 border-b">Sub Total</th>
              </tr>
            </thead>
            <tbody>
              {selectedSalesOrder?.map((pkg, i) => {
                return (
                  <>
                    <tr key={i}>
                      <td className="py-2 px-4 border-b">{i + 1} </td>
                      <td className="py-2 px-4 border-b">{pkg?.item_name} </td>
                      <td className="py-2 px-4 border-b">
                        <CurrencyFormat
                          value={parseFloat(pkg?.item_sales_quantity)?.toFixed(2)}
                          displayType={'text'}
                          thousandSeparator={true}
                        />
                      </td>
                      <td className="py-2 px-4 border-b">
                        <CurrencyFormat
                          value={parseFloat(pkg?.item_sales_rate)?.toFixed(2)}
                          displayType={'text'}
                          thousandSeparator={true}
                        />
                      </td>
                      <td className="py-2 px-4 border-b">
                        {/* <CurrencyFormat value={parseFloat(pkg?.discount_amount )?.toFixed(2)}
                       displayType={'text'} thousandSeparator={true} /> */}
                        <CurrencyFormat value={formatCustomNumber(pkg?.discount_amount)} displayType={'text'} thousandSeparator={true} />
                        <small className="ml-2">{pkg.discount_type_name}</small>
                      </td>
                      <td className="py-2 px-4 border-b">
                        <CurrencyFormat
                          value={parseFloat(pkg?.item_sales_rate * pkg.item_sales_quantity - pkg?.discount_amount)?.toFixed(2)}
                          displayType={'text'}
                          thousandSeparator={true}
                        />
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>

          <div className="flex justify-between items-center mt-8">
            <p className="text-sm text-gray-500">
              <ShippingCheck onStatusCheck={onStatusCheck} />
            </p>
            <h3 className="font-semibold">
              Grand Total:
              <CurrencyFormat
                value={parseFloat(selectedSalesOrder[0]?.sales_order_amount)?.toFixed(2)}
                displayType={'text'}
                thousandSeparator={true}
              />
            </h3>
          </div>
          {showOption && (
            <>
              <small>Delivered on</small>
              <div class="flex items-start">
                <span>{deliveryDate()}</span>
                <span>{deliveryTime()}</span>
              </div>
            </>
          )}

          <div className="mt-4">
            <label className=" text-sm ">Shipment Remark</label>
            <textarea
              {...register('shipment_remark')}
              rows="3"
              className="w-full border border-gray-300 rounded-md shadow-sm p-2"
            ></textarea>
          </div>

          <div className="flex justify-end mt-4">
            <button onClick={() => navigate(-1)} type="button" className="bg-gray-200 text-gray-700 py-2 px-4 rounded-md mr-2">
              Cancel
            </button>
            <button className="bg-blue-600 text-white py-2 px-4 rounded-md">
              {/* {getPackageEditAtom[0]?.Sales_Order_No ? 'Update': 'Save'} */}
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default PackageNewShipping;
